export default __webpack_public_path__ + "static/media/Neddie-Screen-2.54a492d4.png";